import Api from 'app/services/Api'

/**
 * Create match me
 */
export const createMatchMe = (data: MatchMeDTO): Promise<void> =>
  Api.post('/api/v1/users/match_me', {
    data: { match_me: data }
  })

/**
 * Get matches
 */
export const getMatchMe = (params: {
  page: number
}): Promise<MatchMePaginationModel> =>
  Api.get('/api/v1/users/match_me', {
    deserialize: true,
    params
  })

/**
 * Delete match me
 */
export const deleteMatchMe = (matchId: number): Promise<void> =>
  Api.del(`/api/v1/users/match_me/${matchId}`)

/**
 * Move match me to saved search
 */
export const matchMeToSavedSearchMutation = (matchId: number): Promise<void> =>
  Api.put(`/api/v1/users/match_me/${matchId}`)

/**
 * Create unauth match me
 */
export const createUnauthMatchMe = (data: MatchMeDTO): Promise<void> =>
  Api.post('/api/v1/match_me', { data: { match_me: data } })

/**
 * Pause match me
 */
export const pauseMatchMe = (matchId: number): Promise<void> =>
  Api.patch(`/api/v1/users/match_me/${matchId}/pause`)

/**
 * Resume match me
 */
export const resumeMatchMe = (matchId: number): Promise<void> =>
  Api.patch(`/api/v1/users/match_me/${matchId}/unpause`)

/**
 * Unsubscribe guest user from match me
 */
export const unsubscribeGuestUserFromMatchMe = (token: string): Promise<void> =>
  Api.get(`/api/v1/match_me/unsubscribe`, { params: { token } })
